module.exports = __webpack_public_path__ + "img/sell-out-icon.49df25ef.png";